import styled, { css } from 'styled-components';
import { screenSizes, mobileFirstBreakpointScreenSizeMapping, spacingPx } from '@shipt/design-system-themes';
import { gatherPropsByBreakpoint, isNotEmptyObject } from '../helpers/style/gatherPropsByBreakpoints.esm.js';
import isPropValid from '@emotion/is-prop-valid';

const boxConfig = {
    shouldForwardProp: (prop)=>![
            'mask',
            'display',
            'radius'
        ].includes(prop) && isPropValid(prop)
};
const boxStyles = ({ display, flexBasis, flexGrow, flexShrink, margin, marginBottom, marginLeft, marginRight, marginTop, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, radius })=>css([
        `border-radius:`,
        `;display:`,
        `;flex-basis:`,
        `;flex-grow:`,
        `;flex-shrink:`,
        `;margin:`,
        `;margin-bottom:`,
        `;margin-left:`,
        `;margin-right:`,
        `;margin-top:`,
        `;padding:`,
        `;padding-bottom:`,
        `;padding-left:`,
        `;padding-right:`,
        `;padding-top:`,
        `;`
    ], radius === 'full' ? '1000px' : 0, display !== null && display !== void 0 ? display : null, flexBasis !== null && flexBasis !== void 0 ? flexBasis : null, flexGrow !== null && flexGrow !== void 0 ? flexGrow : null, flexShrink !== null && flexShrink !== void 0 ? flexShrink : null, margin !== undefined ? spacingPx(...margin) : null, marginBottom !== undefined ? spacingPx(marginBottom) : null, marginLeft !== undefined ? spacingPx(marginLeft) : null, marginRight !== undefined ? spacingPx(marginRight) : null, marginTop !== undefined ? spacingPx(marginTop) : null, padding !== undefined ? spacingPx(...padding) : null, paddingBottom !== undefined ? spacingPx(paddingBottom) : null, paddingLeft !== undefined ? spacingPx(paddingLeft) : null, paddingRight !== undefined ? spacingPx(paddingRight) : null, paddingTop !== undefined ? spacingPx(paddingTop) : null);
const Box = styled.div.withConfig(boxConfig)(({ display, flexBasis, flexGrow, flexShrink, margin, marginBottom, marginLeft, marginRight, marginTop, mask, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, radius })=>{
    const breakpointStyles = gatherPropsByBreakpoint({
        display,
        flexBasis,
        flexGrow,
        flexShrink,
        margin,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        padding,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop,
        radius
    });
    return css([
        ``,
        ` `,
        ` `,
        ``
    ], boxStyles(breakpointStyles['base']), [
        'sm',
        'md',
        'lg',
        'xl'
    ].map((size)=>isNotEmptyObject(breakpointStyles[size]) && css([
            `@media `,
            `{`,
            `}`
        ], screenSizes[mobileFirstBreakpointScreenSizeMapping[size]], boxStyles(breakpointStyles[size]))), mask && css([
        `overflow:hidden;`
    ]));
});

export { Box };
